import React, { useContext, useEffect } from "react";
import { Card, CardContent } from "@mui/material";
import { useGetFormCommentsQuery } from "../redux/service/formComments";
import { displayNotification } from "helpers";
import { FormDataContext } from "./contexts/FormContext";
import CommentModal from "./preview/modals/CommentModal";
import { FaComments } from "react-icons/fa";

const defaultProps = {
    sectionId: "",
    renderSectionHeader: () => { },
};

const CommentQuestionMatrix = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };

    const formDataContext = useContext(FormDataContext);

    const commentsRes = useGetFormCommentsQuery(
        {
            templateId: formDataContext.templateId,
            movementId: formDataContext.movementId,
            type: props.sectionId === "cm" ? "comment" : "question",
        },
        { skip: formDataContext.mode === "preview" || formDataContext.templateId === undefined }
    );

    useEffect(() => {
        console.log({ commentsRes });
        if (commentsRes.isError) {
            console.error(commentsRes.error);
            displayNotification("error", "Error loading comments.");
        }
    }, [commentsRes]);

    return (
        <>
            <Card sx={{ mb: 2 }}>
                <CardContent sx={{ p: 2 }}>
                    {props.renderSectionHeader(
                        props.sectionId === "cm"
                            ? "Comments Matrix"
                            : props.sectionId === "qm"
                                ? "Questions Matrix"
                                : props.sectionId === "am"
                                    ? "Attachments Matrix"
                                    : ""
                    )}
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="bg-primary text-white">
                                <tr>
                                    <th className="text-center">#</th>
                                    <th>Part / Element</th>
                                    {props.sectionId === "cm" ? <th>Comment</th> : ""}
                                    {props.sectionId === "qm" ? <th>Question</th> : ""}
                                    <th className="text-center">Is Resolved?</th>
                                    <th>User Name</th>
                                    <th className="text-center">Date/Time</th>
                                    {formDataContext.isReadOnly === false && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {commentsRes.isUninitialized ||
                                    (commentsRes.isSuccess && commentsRes.data.length === 0) ? (
                                    <tr>
                                        <td className="text-center" colSpan={8}>
                                            No Data Found
                                        </td>
                                    </tr>
                                ) : commentsRes.isLoading ? (
                                    <tr>
                                        <td className="text-center" colSpan={8}>
                                            Loading Data...
                                        </td>
                                    </tr>
                                ) : commentsRes.isError ? (
                                    <tr>
                                        <td className="text-center" colSpan={8}>
                                            Error Loading Data!
                                        </td>
                                    </tr>
                                ) : commentsRes.isSuccess ? (
                                    commentsRes.data.map((r, k) => (
                                        <tr key={r.id}>
                                            <td className="text-center">{k + 1}</td>
                                            <td>
                                                <div>{r.part_name}</div>
                                                {r.element_number && (
                                                    <div>
                                                        <strong className="me-1">Element #:</strong>
                                                        {r.element_number} {r.relationElement.label}
                                                    </div>
                                                )}
                                                {![undefined, null, 0, '0'].includes(r.cc_id) && (
                                                    <div>
                                                        <strong className="me-1">Critical Competency:</strong>
                                                        {r.cc_name}
                                                    </div>
                                                )}
                                            </td>
                                            <td>{r.content}</td>
                                            <td className="text-center">{r.is_resolved ? "Yes" : "No"}</td>
                                            <td>{r.user_name}</td>
                                            <td className="text-center">{r.created_date}</td>
                                            <td className="text-center">
                                                <CommentModal
                                                    elementId={r.element_id}
                                                    ccId={r.cc_id ?? ""}
                                                    label={
                                                        <>
                                                            <FaComments />
                                                            <span className="ms-1">View</span>
                                                        </>
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : null}
                            </tbody>
                        </table>
                    </div>
                </CardContent>
            </Card>
        </>
    );
};

export default CommentQuestionMatrix;
